module.exports = __webpack_public_path__ + "img/1f5afb610f9531461d19b5915db22238.6353363a.jpg";